/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { DEPARTMENT_SERVICE } from '../EndPoints';

// List all the department
export const GetAllDepartments = createAsyncThunk(
    'departmentSection/getAllDepartments',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(DEPARTMENT_SERVICE.getAllDepartments, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// create department
export const CreateDepartment = createAsyncThunk(
    'departmentSection/createDepartment',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(DEPARTMENT_SERVICE.createDepartment, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const UpdateDepartment = createAsyncThunk(
    'departmentSection/updateDepartment',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DEPARTMENT_SERVICE.updateDepartment, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const DeleteDepartment = createAsyncThunk(
    'departmentSection/deleteDepartment',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`${DEPARTMENT_SERVICE.deleteDepartment}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// add user to department by it id
export const AddDepartmentById = createAsyncThunk(
    'departmentSection/addDepartmentById',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DEPARTMENT_SERVICE.addDepartmentById(params?.id), params?.userids)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// remove all user from department
export const RemoveAlluserFromDepartment = createAsyncThunk(
    'departmentSection/removeAlluserFromDepartment',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${DEPARTMENT_SERVICE.removeAlluserFromDepartment}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// list of all user from department with pagination
export const GetUsersDepartment = createAsyncThunk(
    'departmentSection/getUsersDepartment',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`${DEPARTMENT_SERVICE.getUsersDepartment}${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ListUsersDepartment = createAsyncThunk(
    'departmentSection/listUsersDepartment',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${DEPARTMENT_SERVICE.listUsersDepartment}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// remove all user from department
export const RemoveUserFromDepartment = createAsyncThunk(
    'departmentSection/removeUserFromDepartment',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DEPARTMENT_SERVICE.removeUserFromDepartment, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);